import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import ToastModal from "views/components/ToastModal";
import { lendingPartner } from "assets/properties/properties";
const PartnerCreate = ({ props, classes }) => {
  const navigate = useNavigate();
  const params = useParams();
  const [partnerName, setPartnerName] = useState("");
  const [partnerNameState, setPartnerNameState] = useState(false);
  const [partnerCodeState, setPartnerCodeState] = useState(false);
  const [partnerCode, setPartnerCode] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [redirectURL, setRedirectURL] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [isSelfActive, setIsSelfActive]= useState(false)
  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL);
    }
  };
  const isValidated = () => {
    if (partnerName === "") {
      setPartnerNameState(true);
    } else {
      setPartnerNameState(false);
    }
    if (partnerCode === "") {
      setPartnerCodeState(true);
    } else {
      setPartnerCodeState(false);
    }
    if (partnerName && partnerCode) {
      return true;
    } else {
      return false;
    }
  };
  useEffect(() => {
    if (params.partnerId) {
      GetData();
    }
  }, []);
  const GetData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.PARTNER_GETDATA + params.partnerId,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      setPartnerName(result?.data?.name);
      setPartnerCode(result?.data?.code);
      setIsActive(result?.data?.active);
      setIsSelfActive(result?.data?.self)
    }
  };

  const updateRoleInformation = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.PARTNER_UPDATE + params?.partnerId,
      method: "PUT",
      authToken: authToken,
      data: {
        name: partnerName,
        code: partnerCode?.toUpperCase(),
        active: isActive,
        self: isSelfActive,
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      return "SUCCESS";
    }
  };
  const saveRoleInformation = async () => {
    setCallInProgress(true);
    const bulkData = {
      name: partnerName,
      code: partnerCode?.toUpperCase(),
      active: isActive,
      self: isSelfActive,

    };
    const res = await apiHandler({
      url: endpoint.PARTNER_CREATE,
      method: "POST",
      authToken: authToken,
      data: bulkData,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      return "SUCCESS";
    }
  };
  const handleroleSubmit = async (event) => {
    console.log(isValidated(), "ashdkahjsk");
    if (isValidated()) {
      toastUpdate("", "", false);
      let status = "";
      if (params.partnerId) {
        status = await updateRoleInformation();
      } else {
        status = await saveRoleInformation();
      }
      if (status === "SUCCESS") {
        const msg = params.partnerId
          ? lendingPartner?.updateMsg
          : lendingPartner?.createMsg;
        toastUpdate("Success", msg, true);
        setRedirectURL(`/coreservice/lendingpartner`);
      }
    }
  };

  const statusUpdate = async (checked) => {
    setIsActive(checked);
  };

  const selfStatusUpdate = async (checked)=>{
    setIsSelfActive(checked)
  }
  const handlecancelrole = () => {
    navigate("/coreservice/lendingpartner");
  };
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label={
            params.partnerId ? lendingPartner?.title2 : lendingPartner?.title1
          }
          button1="Save"
          button2=" Cancel"
          button1click={handleroleSubmit}
          button2click={handlecancelrole}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Partner Name"
              required
              error={partnerNameState}
              id="lp_min_role"
              value={partnerName || ""}
              setState={setPartnerName}
              setError={setPartnerNameState}
              type="noCapital"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Partner Code"
              required
              error={partnerCodeState}
              id="partnerCode"
              value={partnerCode?.toUpperCase() || ""}
              setState={setPartnerCode}
              setError={setPartnerCodeState}
              disabled={params?.partnerId}
              type="noCapital"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <p style={{ fontWeight: "bold", display:'flex', alignItems:'center', gap:'5px' }}>
              {" "}
              <input
                id="selectAll"
                type="checkbox"
                checked={isActive}
                className={classes.checkboxInput}
                onChange={(e) => statusUpdate(e.target.checked)}
                style={{width:'20px', height:'20px'}}
              />{" "}
              Active
            </p>
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <p style={{ fontWeight: "bold", display:'flex', alignItems:'center', gap:'5px' }}>
              {" "}
              <input
                id="selectAll"
                type="checkbox"
                checked={isSelfActive}
                className={classes.checkboxInput}
                onChange={(e) => selfStatusUpdate(e.target.checked)}
                  style={{width:'20px', height:'20px'}}
              />{" "}
              Self
            </p>
          </Grid>
        </Grid>
      </Grid>
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}

      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </Grid>
  );
};

export default PartnerCreate;
